import React, { FC, useRef } from 'react';

import CalendarMonth from './calendar-month';
import { Calendar, MonthWithWeeks } from '../../utils/bookings/booking-types';
import * as CSS from './availability.styles';

type CalendarYearProps = {
  calendar: Calendar;
};

const CalenderYear: FC<CalendarYearProps> = ({ calendar }) => {
  return (
    <div>
      <div>
        <h3>{calendar.year} Season</h3>
      </div>
      <CSS.CalendarContainer>
        {calendar.months.map((month: MonthWithWeeks) => {
          return <CalendarMonth year={calendar.year} month={month} key={`${month.name}-${calendar.year}`} />;
        })}
      </CSS.CalendarContainer>
    </div>
  );
};

export default CalenderYear;
